<template>
  <dropdown
    class="domain-list-item-actions"
    :data-border="false"
    dataMenuWidth="125px"
    data-icon="mdi-dots-vertical"
    @hidden="hideEveryModal"
  >
    <p class="domain-list-item-actions-item pointer" @click.stop="emitSelected">
      {{ $t("message.email.message.viewDetails") }}
    </p>

    <p
      class="domain-list-item-actions-item pointer"
      @click.stop="showDeleteModal"
    >
      {{ $t("message.generics.message.delete") }}
    </p>

    <confirmation-modal
      :value="showAutomationDeleteModal"
      :confirm-label="$t('message.generics.message.confirm')"
      @confirm="deleteDomain"
      @cancel="closeDeleteModal"
    >
      <span slot="heading">
        {{ $t("message.email.message.deleteDomain") }}
      </span>
      <span>
        {{ $t("message.email.message.deleteDomainConfirmation") }}
      </span>
    </confirmation-modal>
  </dropdown>
</template>

<script>
import ConfirmationModal from "@components/ConfirmationModal";
import Dropdown from "@components/Dropdown";
import EventBus from "@packages/event-bus";

export default {
  components: {
    Dropdown,
    ConfirmationModal,
  },

  data() {
    return {
      showAutomationDeleteModal: false,
    };
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {},

  methods: {
    hideEveryModal() {
      this.closeDeleteModal();
    },
    showDeleteModal() {
      this.showAutomationDeleteModal = true;
    },
    closeDeleteModal() {
      this.showAutomationDeleteModal = false;
    },
    async deleteDomain() {
      try {
        EventBus.$emit("SHOW_SPINNER");

        await this.$api.marketing.email.dns.delete({
          domainId: this.item.senderDomainId,
        });

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: this.$t("message.successMessages.message.domainDeleted"),
        });

        this.closeDeleteModal();

        this.$emit("deleted");
      } catch (error) {
        //empty
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
      }
    },
    emitSelected() {
      this.$emit("selected");
    },
  },
};
</script>

<style lang="scss" scoped>
.domain-list-item-actions {
  .domain-list-item-actions-item {
    margin-bottom: 0px;
    font-size: 12px;
    color: #707070;
    font-weight: 600;
    margin-bottom: 5px;

    &:hover {
      transform: translateY(-1px);
    }

    &:active {
      box-shadow: none;
      transform: translateY(1px);
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
